import { FC } from 'react';
import { IconDefinition } from '~/assets';
import { IconOption, OptionButton } from './styles';

type Props = {
  id: string;
  icon: IconDefinition;
  label: string;
  disabled?: boolean;
  onPress(): void;
  type?: 'primary' | 'secondary' | 'tertiary';
};

const OptionsList: FC<Props> = ({
  id,
  icon,
  label,
  disabled = false,
  onPress,
  type = 'tertiary',
}) => (
  <OptionButton
    id={id}
    tertiary={type === 'tertiary'}
    secondary={type === 'secondary'}
    onPress={onPress}
    disabled={disabled}
  >
    <IconOption icon={icon} />
    {label}
  </OptionButton>
);

export default OptionsList;
